const WhyXaneContent = {
  heading: "Why Xane?",
  card1: {
    heading: ["Breakdowns can happen anytime.", "Diagnostics aren't optional."],
    para1:
      "Current assistance workflows are broken. Paper manuals and service networks are often inaccessible. Customers struggle to find accurate, reliable, and timely information to handle everything from simple to complex queries.",
    para2:
      "Xane provides scan-to-diagnose assistance flows that are product-specific and directly connected with your brand's service networks.",
  },
  card2: {
    heading: ["Customers have questions 24/7.", "Answering them is costly."],
    para1:
      "Product onboardings often feel incomplete. Customers aren't equipped to handle new and complex features, which reduces a product's perceived value.",
    para2:
      "Xane delivers engagement technology for all queries and features - providing answers whenever needed, at a fraction of the cost, directly in your customers' hands.",
  },
  card3: {
    heading: ["Post-sales funnels are leaky ...", " Unless you use Xane."],
    para1:
      "Without a digital interface, brand-authorized channels miss customers at the right moment, especially for lucrative service revenue streams.",
    para2:
      "Retain users and increase conversions by up-selling products and services through in-built paywalls and engagement tools.",
  },
};

export default WhyXaneContent;
